export default [
  {
    path: '/introduction/auth_notice',
    name: 'auth_notice',
    meta: {
      requiresAuth: false
    },
    component: () => import('@/components/introduction/customer_authentication_notice')
  },
  {
    path: '/help/info',
    name: 'help_info',
    component: () => import('@/components/menus/help/info')
  },
  {
    path: '/help/admin_info',
    name: 'admin_info',
    meta: {
      requiresAuth: true
    },
    component: () => import('@/components/menus/help/admin_info')
  },
  {
    path: '/help/agent_info',
    name: 'agent_info',
    meta: {
      requiresAuth: true
    },
    component: () => import('@/components/menus/help/agent_info')
  }
]



// WEBPACK FOOTER //
// ./src/router/subRoutes/introRouter.js